import { render, staticRenderFns } from "./orderWayBillDetail.vue?vue&type=template&id=476e26b5&scoped=true"
import script from "./orderWayBillDetail.vue?vue&type=script&lang=js"
export * from "./orderWayBillDetail.vue?vue&type=script&lang=js"
import style0 from "./orderWayBillDetail.vue?vue&type=style&index=0&id=476e26b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e26b5",
  null
  
)

export default component.exports